import create from 'zustand';
import produce from 'immer';
import arrayMove from 'array-move';

const BLANK_COURSE_INITIAL = {
	courses: [],
	edited: false
};

export const useBlankCourseStore = create(set => ({
	...BLANK_COURSE_INITIAL,

	// Handle course addition
	onAddCourse: (course) => set(produce(state => {
		state.courses.push({
			...course,
			order: 0
		});
		
		// Update edited state
		state.edited = true;
	})),

	// Handle course addition
	onRemoveCourse: (id) => set(produce(state => {
		state.courses = state.courses.filter(course => course.id !== id);

		// Update edited state
		state.edited = true;
	})),
	
	// Handle course sort
	onSort: ({ oldIndex, newIndex }) => set(produce(state => {
		// Sort courses by given indexes
		const sorted = arrayMove(state.courses, oldIndex, newIndex);

		// Update course order
		state.courses = sorted.map((course, idx) => ({
			...course,
			order: idx + 1
		}));

		// Update edited state
		state.edited = true;
	})),

	// Handle course sort
	onUpdate: (activeId, overId) => set(produce(state => {
		// Sort courses by given indexes
		const course = state.courses.find(c => c.id === activeId);

		// Update course order
		course.order = overId;

		// Update edited state
		state.edited = true;
	})),

	// Initialize course's state
	onInit: (courses) => set({
		courses: courses.map(course => ({
			...course.course,
			order: course.order
		}))
	}),

	// Reset store to initial state
	onReset: () => set({
		...BLANK_COURSE_INITIAL
	})
}));